import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';

/** The tabs of the module «Города»: the cities and the contacts of the countries (the WhatsApp of the operator of a country). */
@Component({
  selector: 'hc-cities-tabs',
  templateUrl: './cities-tabs.component.html',
  styleUrls: ['./cities-tabs.component.less'],
  providers: [provideTranslocoScope('cities')],
  imports: [RouterLink, RouterLinkActive, TranslocoPipe]
})
export class CitiesTabsComponent {
  protected readonly citiesLink = {paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored'} as const;
}
